// extracted by mini-css-extract-plugin
export var container = "_6u-0";
export var fallback = "_6u-5";
export var fallbackIcon = "_6u-6";
export var hidden = "_6u-2";
export var image = "_6u-3";
export var loaded = "_6u-4";
export var placeholder = "_6u-1";